import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "weekendCycle",
    "tourHoursGuideLabel",
    "tourHoursNonGuideLabel",
    "calculationPeriodRow"
  ]

  static values = {
    originalContractId: Number
  }

  connect() {
    const contractSelect = this.element.querySelector('select[name="user_contract[contract_id]"]')
    if (contractSelect) {
      this.updateCalculationPeriodVisibility(contractSelect.value)
    }
  }

  toggleEdit(event) {
    this.element.classList.toggle("edit")
    event.preventDefault()
  }

  switchContract(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const selectedContractId = event.target.value

    const isGuide = selectedOption.dataset.isGuide === 'true';
    // Toggle Weekend cycle
    this.weekendCycleTarget.querySelector("select").selectedIndex = 0;
    this.weekendCycleTarget.classList.toggle("disabled", isGuide);

    this.tourHoursGuideLabelTarget.classList.toggle("d-none", !isGuide);
    this.tourHoursNonGuideLabelTarget.classList.toggle("d-none", isGuide);

    // Hide calculation period checkbox if different contract type is selected
    this.updateCalculationPeriodVisibility(selectedContractId)
  }

  updateCalculationPeriodVisibility(selectedContractId) {
    if (!this.hasCalculationPeriodRowTarget) {
      return
    }

    if (this.originalContractIdValue) {
      // For existing contracts, hide checkbox if different type is selected
      if (selectedContractId != this.originalContractIdValue) {
        this.calculationPeriodRowTarget.classList.add("d-none")
      } else {
        this.calculationPeriodRowTarget.classList.remove("d-none")
      }
    }
    // For new contracts, always keep it visible (handled by server-side)
  }

  get hasCalculationPeriodRowTarget() {
    return this.targets.has("calculationPeriodRow")
  }

  delete(event) {
    this.element.remove()
    event.preventDefault()
  }

  refresh(event) {
    const [data, status, xhr] = event.detail
    const response = JSON.parse(xhr.response)
    this.element.outerHTML = response.user_contract
  }

  error(event) {
    const [data, status, xhr] = event.detail
    const response = JSON.parse(xhr.response)
    
    // Handle errors
    if (response.errors && response.errors.length) {
      const errorContainer = this.element
        .querySelector(".row-errors")
      errorContainer.classList.remove("d-none")
      errorContainer.innerText = response.errors[0]
    }
  }
}
